<style scoped>
    th{
        padding:10px
        }
    td {
        padding-left: 10px;
        padding-right:10px;
        padding:1px;
        font-size:11px;
    }
    tr.border-top th {
        border-bottom: 1px solid #d9d9d9;
    }
    .form-control, .form-control:focus {
        padding: 0px !important;
        font-size: 12px;
        height: 25px;
        border: none;
        border-radius: 0px;
    }
    .form-control, .form-control:focus {
            border-bottom: 1px solid #d9d9d9;
        }
    .form-control {
        border-bottom: 1px solid #d9d9d9;
    }
    .has-warning .form-control {
        border: none;
        border-bottom: 1px solid orange;
    }
    .has-error .form-control {
        border: none;
        border-bottom: 1px solid red;
    }
    .has-success .form-control {
        border: none;
        border-bottom: 1px solid green;
    }
    /*input{
        border:none;
        border-bottom: 1px solid black;
    }*/
</style>
<template>
    <div style="padding:10px;   border: 2px solid #dce4ec;">
        <table class="table border-top">
            <tr>
                <th>Status</th>
                <th>Round</th>
                <th>Time</th>
                <th style="min-width:70px">Colour</th>
                <th>Dosage</th>
                <th></th>
            </tr>

            <template v-for="(round,index) in controller.Rounds">
                <tr class="">
                    <td class="text-center">
                        <div v-if="round.hasError">
                            <i class="fa fa-exclamation-triangle text-danger"></i>
                        </div>
                        <div v-else>
                            <i v-if="round.Status=='Current' && round.Dosage.value > 0" class="fa fa-check text-success"></i>
                            <i v-if="round.Status=='New'  && round.Dosage.value > 0" class="fa fa-plus text-success"></i>
                            <i v-if="round.Status=='New'  && round.Dosage.value == 0" class="fa fa-plus text-warning"></i>
                        </div>
                    </td>
                    <td>
                        <div class="form-group" v-bind:class="{ 'has-error' : round.Name.hasError,'has-warning' : round.Name.hasWarning ,'has-success' : round.Name.hasSuccess}" style="height:100%">
                            <input type="text" class="form-control" v-model="round.Name.value" placeholder="Round Name" />
                            <!--<span class="help-block" v-if="round.Name.hasWarning || round.Name.hasError" style="margin-top:10px">{{round.Name.message}}</span>-->
                        </div>
                    <td>
                        <div class="form-group" v-bind:class="{ 'has-error' : round.Time.hasError,'has-warning' : round.Time.hasWarning ,'has-success' : round.Time.hasSuccess}" style="height:100%">
                            <input type="text" class="form-control" v-model="round.Time.value" placeholder="HH:MM" />
                        </div>
                    </td>
                    <td><input type="color" v-model="round.HexColour.value" /></td>
                    <td>
                        <div class="form-group" v-bind:class="{ 'has-error' : round.Dosage.hasError,'has-warning' : round.Dosage.hasWarning ,'has-success' : round.Dosage.hasSuccess}" style="height:100%">
                            <input type="text" class="form-control" v-model="round.Dosage.value" placeholder="Dosage" style="width:40px" />
                        </div>

                    </td>
                    <td><a :disabled="!(round.Dosage.value > 0 || round.Status=='New')" class="btn btn-sm btn-link text-warning" style="padding:1px" @click.prevent.stop="controller.Remove(round)"><i class="fa fa-15x fa-trash"></i>&nbsp; Delete</a></td>
                </tr>
                <tr>
                    <td></td>
                    <td colspan="10">
                        <span v-if="round.hasError" class="text-danger">
                            {{round.Name.message }} {{round.Time.message }} {{round.HexColour.message }} {{round.Dosage.message }}
                        </span>
                    </td>
                </tr>
            </template>
            <tr class="border-top">
                <td colspan="1"></td>
                <td colspan="100">
                    <a class="btn btn-sm btn-link btn-primary" style="padding:1px" @click.prevent.stop="controller.Add"><i class="fa fa-15x fa-plus"></i>&nbsp; Add</a>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
    import Formatter from "../../corecontrols/formatters/Formatter";
    import Dal from './../../../scripts/dataaccess';
    import RoundSelectorController from './RoundSelectorController'
    import moment from 'moment';
    export default {
        //props: ['value', 'ward'],
        props: ['controller'],
        mounted() {
            console.log("Controller ", this.controller)
        },
        computed : { },
        data: function () {
            return {

            }
        },
        methods: {
            HexColor: c => Formatter.HexColour(c),
            FormatTime: t => new moment(t).format("hh:mm"),
        }
    }
</script>



// WEBPACK FOOTER //
// RoundSelector.scp.html?13c63702